import { toast } from "react-hot-toast";
import { supabase } from "@/lib/supabaseClient";
import { Access } from "@/types/matching";



interface AccessListProps {
  accesses: Access[];
}


export default function AccessList({ accesses }: AccessListProps) {
  const handleCopy = (token: string) => {
    // Doit pointer vers /matching/scoring?t=... — c'est le seul endpoint
    // (`/api/heirs/verify`) qui vérifie réellement ce token contre
    // `beneficiaries_access`. L'ancienne URL "/matching/questionnaire?token="
    // ne correspondait à aucune route existante.
    const url = `${window.location.origin}/matching/scoring?t=${token}`;
    navigator.clipboard.writeText(url);
    toast.success("Lien copié dans le presse-papier !");
  };
const handleSendEmail = async (token: string, name: string, email: string) => {
const apiUrl = process.env.VITE_APP_API_URL || "http://localhost:5001";
const res = await fetch(`${apiUrl}/api/matching/send-link`, {    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ token, name, email }),
  });

  if (res.ok) toast.success("Email envoyé !");
  else toast.error("Erreur lors de l'envoi");
};
const handleDelete = async (id: string) => {
  const confirm = window.confirm("Supprimer cet accès ?");
  if (!confirm) return;

  const { error } = await supabase
    .from("beneficiaries_access")
    .delete()
    .eq("id", id);

  if (error) {
    toast.error("Erreur lors de la suppression");
  } else {
    toast.success("Accès supprimé !");
    // Rechargement de la liste parent (tu peux le passer en prop si besoin)
    if (typeof window !== "undefined") window.location.reload(); // rapide
  }
};

  return (
    <div className="mt-12 space-y-6">
      <h2 className="text-xl font-semibold mb-4">Accès déjà créés :</h2>
      {accesses.length === 0 && (
        <p className="text-gray-500">Aucun accès encore créé.</p>
      )}
      {accesses.map((a, idx) => (
        <div key={idx} className="bg-white/60 backdrop-blur p-4 rounded-xl shadow-md flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div>
            <p className="font-semibold">{a.name}</p>
            <p className="text-sm text-gray-600">{a.email}</p>
            <p className="text-xs text-gray-500 mt-1">Valide jusqu'au {new Date(a.expires_at).toLocaleDateString()}</p>
          </div>
          <div className="flex gap-2">
            <button
              onClick={() => handleCopy(a.access_token)}
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-full transition"
            >
              Copier le lien
            </button>
            <button
  onClick={() => handleSendEmail(a.access_token, a.name, a.email)}
  className="bg-green-600 hover:bg-green-700 text-white font-semibold py-2 px-4 rounded-full transition"
>
  Envoyer Email
</button>
<button
  onClick={() => handleDelete(a.id)}
  className="bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-full transition"
>
  Supprimer
</button>

          </div>
        </div>
      ))}
    </div>
  );
}
